import formsBackendClient, { ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';

const updateDynamicPdfTemplateAsset = async (id: string, data: ApiDefinition['/dynamic-pdf-templates-assets/{id}']['PUT']['body']):
 Promise<ApiDefinition['/dynamic-pdf-templates-assets/{id}']['PUT']['response']> => {
  const response = await formsBackendClient.put(`/dynamic-pdf-templates-assets/${id}`, data);
  return response.data;
};

export default updateDynamicPdfTemplateAsset;
